import AppSettingsService from '@/services/app-settings.service'

const state = {
  config: null
}

const mutations = {
  SET(state, payload) {
    state.config = payload
  }
}

const actions = {
  fetch: async ({ commit, state }, payload) => {
    payload = payload || { force: false }

    if (state.config && !payload.force)
      return state.config

    return AppSettingsService.getSiteConfig().then(data => {
      commit('SET', data)
      return data
    })
  }
}

const getters = {
  isCloud: (state, getters) => {
    return state.config?.isCloud
  },
  permanentPrice: (state) => {
    return state.config.permanentPrice
  },
  cloudPrice: (state) => {
    return state.config.cloudPrice
  },
  titlePart1: (state) => {
    return state.config.titlePart1
  },
  titlePart2: (state) => {
    return state.config.titlePart2
  },
  fullTitle: (state) => {
    return state.config.fullTitle
  },
  longTitle: (state) => {
    return state.config.longTitle
  },
  routeToPlansAsDefault: (state) => {
    return state.config.routeToPlansAsDefault
  },
  showSponsoreCheck: (state) => {
    return state.config.showSponsoreCheck
  },
  baseUrl: (state) => {
    return state.config.baseUrl
  },
  activeParts: (state) => {
    return state.config.activeParts
  },
  customerCode: (state) => {
    return state.config.customerCode
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
